export const bonificoBankAccount = {
  accountHolder: "Norma's Teaching S.R.L.",
  iban: "IT02O0200866361000106010047",
  bicSwift: "UNCRITM1V33",
  bankName: "UniCredit",
};
